import { AppProviders } from '@/providers/AppProviders';
import { AppRoutes } from '@/routes';
import { TenantBootGate } from '@/components/shared/tenant-boot-gate';

export function App() {
  return (
    <AppProviders>
      {/* Inside AppProviders (it needs the query client), outside the router:
          an unknown or suspended workspace has no business routing at all. */}
      <TenantBootGate>
        <AppRoutes />
      </TenantBootGate>
    </AppProviders>
  );
}
